import { render, staticRenderFns } from "./MeRankCard.vue?vue&type=template&id=035bbbd7&scoped=true&"
import script from "./MeRankCard.vue?vue&type=script&lang=js&"
export * from "./MeRankCard.vue?vue&type=script&lang=js&"
import style0 from "./MeRankCard.vue?vue&type=style&index=0&id=035bbbd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035bbbd7",
  null
  
)

export default component.exports